module.exports = __webpack_public_path__ + "quintype-logo-13bfa64fb88faf7fb13a.png";